import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertComponent } from '../common/alert/alert.component';
import { adminService } from '../services/admin.service';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-keyvault',
  templateUrl: './keyvault.component.html'
})
export class KeyvaultComponent implements OnInit {

  isLoading = false;

  public keyvaultDetailsForm = new UntypedFormGroup({
    keyvaultName: new UntypedFormControl('Az-TenantName-DEVKV', Validators.required),
    accessRights: new UntypedFormControl('', Validators.required)
  });
  resourceList: any;
  constructor(public dialogRef: MatDialogRef<KeyvaultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalService,
    public adminservice: adminService) { }

  ngOnInit(): void {
    let environment = (this.globalService.environment + 'KV').toUpperCase();
    let tenantName = '';
    if (typeof this.data === "string") {
      tenantName = this.data.replace(/_/g, "-");
    }
    tenantName = (tenantName.length >= 15) ? (tenantName).slice(0, 15) : tenantName;
    this.keyvaultDetailsForm.controls['keyvaultName'].setValue('Az-' + tenantName + '-' + environment);
    this.fetchResourceList();
  }

  /**
   * Fetches list of resources from api
   */
  fetchResourceList() {
    this.adminservice.getResourceList().subscribe(data => {
      this.resourceList = data;
    }, (error) => {
      console.log(error);
    });
  }

  /**
   * calls create keyvault api in backend and shows results/error
   */
  createKeyvault() {
    let tenantName = this.keyvaultDetailsForm.controls['keyvaultName'].value;
    this.isLoading = true;
    let keyVaultName = '';
    if (typeof tenantName === "string") {
      keyVaultName = tenantName.replace(/_/g, "-");
    }
    this.adminservice.createKeyvault(keyVaultName,
      this.keyvaultDetailsForm.controls['accessRights'].value).subscribe(data => {
        let kvUrl = 'https://' + keyVaultName + '.vault.azure.net';
        const alertData = {
          success: true,
          message: 'Key vault has been created successfully with url:' + kvUrl
        };
        this.globalService.showAlert(AlertComponent, alertData);
        this.isLoading = false;
        this.dialogRef.close(kvUrl);

      }, (error) => {
        console.log(error);
        const alertData = {
          success: false,
          message: "A vault with the same name already exists in deleted state."
        };
        this.globalService.showAlert(AlertComponent, alertData);
        this.isLoading = false;
      });
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }
}
